import { LitElement as f, unsafeCSS as c } from "lit";
import { property as i } from "lit/decorators.js";
import m from "../../foundations/icon/icon.style.css.js";
import y from "../../shared/reset.style.css.js";
import { booleanType as p } from "../../utils/property-types.js";
import v from "./header.style.css.js";
import { headerTemplate as _ } from "./header.template.js";
var E = Object.defineProperty, s = (h, e, t, d) => {
  for (var o = void 0, n = h.length - 1, a; n >= 0; n--)
    (a = h[n]) && (o = a(e, t, o) || o);
  return o && E(e, t, o), o;
};
class r extends f {
  constructor() {
    super(), this.title = "", this.titleText = "", this.titleFullWidth = !1, this.area = void 0, this.logoSrc = void 0, this.jcef = !1, this.showEndVisit = !1, this.hideEndVisitDivider = !1, this.endVisitLabel = "Finalitzar visita", this._isBreakpointSm = !1, this._resizeTimer = null, this._handleResizeBound = this._handleResize.bind(this);
  }
  static get styles() {
    return [c(y), c(m), c(v)];
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("resize", this._handleResizeBound), this._handleResize();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), window.removeEventListener("resize", this._handleResizeBound);
  }
  _propagateProperties() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("slot");
    e && e.forEach((d) => {
      d.assignedElements().forEach((n) => {
        this.jcef ? n.setAttribute("jcef", "true") : n.removeAttribute("jcef");
      });
    });
  }
  _updateSlotsDivider() {
    var t;
    const e = (t = this.shadowRoot) == null ? void 0 : t.querySelectorAll("slot");
    e && e.forEach((d) => {
      const n = d.assignedNodes({ flatten: !0 }).filter((l) => {
        var u;
        return !(l.nodeType === Node.TEXT_NODE && ((u = l == null ? void 0 : l.textContent) == null ? void 0 : u.trim()) === "");
      }).length > 0, a = d.previousElementSibling;
      a && a.classList.contains("dss-header-divider") && (a.style.display = n ? "block" : "none");
    });
  }
  _handleEndVisit() {
    this.dispatchEvent(new CustomEvent("end-visit", { bubbles: !0, composed: !0 }));
  }
  _handleResize() {
    this._resizeTimer && clearTimeout(this._resizeTimer), this._resizeTimer = setTimeout(() => {
      const e = window.innerWidth, t = this.jcef ? 1418 : 1439;
      this._isBreakpointSm = e <= t, this.requestUpdate();
    }, 250);
  }
  async firstUpdated() {
    await this.updateComplete, this._propagateProperties(), this._updateSlotsDivider();
  }
  updated(e) {
    super.updated(e), e.has("title") && queueMicrotask(() => {
      this.title !== "" && (this.titleText = this.title);
    });
  }
  render() {
    return _(this);
  }
}
s([
  i({ type: String })
], r.prototype, "title");
s([
  i({ type: String })
], r.prototype, "titleText");
s([
  i(p)
], r.prototype, "titleFullWidth");
s([
  i({ type: String })
], r.prototype, "area");
s([
  i({ type: String })
], r.prototype, "logoSrc");
s([
  i(p)
], r.prototype, "jcef");
s([
  i(p)
], r.prototype, "showEndVisit");
s([
  i(p)
], r.prototype, "hideEndVisitDivider");
s([
  i({ type: String })
], r.prototype, "endVisitLabel");
export {
  r as Header
};
//# sourceMappingURL=header.js.map
